import { MessageIcon, TerminalIcon } from "~/lib/icons";
import type { QuotedContextKind } from "~/lib/quotedContext";

import { cn } from "~/lib/utils";
import {
  COMPOSER_INLINE_CHIP_CLASS_NAME,
  COMPOSER_INLINE_CHIP_ICON_CLASS_NAME,
  COMPOSER_INLINE_CHIP_LABEL_CLASS_NAME,
} from "../composerInlineChip";
import { Tooltip, TooltipPopup, TooltipTrigger } from "../ui/tooltip";

interface QuotedContextInlineChipProps {
  kind: QuotedContextKind;
  label: string;
  tooltipText: string;
  expired?: boolean;
}

export function QuotedContextInlineChip(props: QuotedContextInlineChipProps) {
  const { kind, label, tooltipText, expired = false } = props;
  // The icon is what tells the two apart at a glance: the labels ("Terminal 1 lines 4-5" vs
  // "Assistant message") are too similar in shape to read as different things while typing.
  const Icon = kind === "message" ? MessageIcon : TerminalIcon;

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <span
            className={cn(
              COMPOSER_INLINE_CHIP_CLASS_NAME,
              expired && "border-destructive/35 bg-destructive/8 text-destructive",
            )}
            data-quoted-context-kind={kind}
            data-quoted-context-expired={expired ? "true" : undefined}
          >
            <Icon
              className={cn(
                COMPOSER_INLINE_CHIP_ICON_CLASS_NAME,
                "size-3.5",
                expired && "opacity-100",
              )}
            />
            <span className={COMPOSER_INLINE_CHIP_LABEL_CLASS_NAME}>{label}</span>
          </span>
        }
      />
      <TooltipPopup side="top" className="max-w-80 whitespace-pre-wrap leading-tight">
        {tooltipText}
      </TooltipPopup>
    </Tooltip>
  );
}
